// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2238f0a3","241":"1586e872","674":"179455b2","848":"e9ffbbb3"}[chunkId] + ".chunk.js";
};